import { render, staticRenderFns } from "./CancelPayment.vue?vue&type=template&id=0a950ec0&scoped=true&"
import script from "./CancelPayment.vue?vue&type=script&lang=ts&"
export * from "./CancelPayment.vue?vue&type=script&lang=ts&"
import style0 from "./CancelPayment.vue?vue&type=style&index=0&id=0a950ec0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a950ec0",
  null
  
)

export default component.exports